// extracted by mini-css-extract-plugin
export var home = "bgcontact-module--home--26ALw";
export var header = "bgcontact-module--header--3nJlu";
export var pstyles = "bgcontact-module--pstyles--2iIcQ";